export default __webpack_public_path__ + "static/media/facebook-logo.232330ab.svg";